import { put, takeLatest } from 'redux-saga/effects'
import { toast } from 'react-toastify';
import { signIn, signInFailure, signInSuccess } from '../reducers/authSlice';
import * as authService from '../services/authService';

function* authSaga() {

    function* postSignIn(action) {
        try {
            let data = yield authService.signIn(action.payload);
            if (data.status) {
                return yield put(signInSuccess(data));
            }
            throw new Error(data.message);
        } catch (error) {
            toast.error(error.message, {
                theme: 'colored',
                style: {
                    fontSize: 14
                }
            });
            yield put(signInFailure(error.message));
        }
    }

    yield takeLatest(signIn.type.toString(), postSignIn);
}

export default authSaga;